import { defineStore } from 'pinia';
import {useUserStore} from "@/user/stores/user.store";
import {useLanguageStore} from "@/shared/stores";
import API from "@/shared/helpers/API";

export const useReferralsStore = defineStore('referral', {
	state: () => ({
		totalReferralsRewards: 0,
		referralsRewards: [],
		referralsFilters: {}
	}),
	getters: {
		rewardsIds: state => {
			let finalIds = {};
			if(!state.referralsRewards) return finalIds;
			for(let i = 0; i < state.referralsRewards.length; i++) {
				finalIds[state.referralsRewards[i].referral_reward_id] = state.referralsRewards[i];
			}
			return finalIds;
		},
	},
	actions: {
		normalizeRewards(referralRewards) {
			let normalizedRewards = referralRewards.map(reward => {
				reward.referral_reward_id = Number(reward.referral_reward_id);
				reward.business_id = Number(reward.business_id);
				reward.user_id = Number(reward.user_id);
				reward.invited_by_user_id = Number(reward.invited_by_user_id);
				reward.amount = Number(reward.amount);
				return reward;
			})
			let finalRewards = [];
			normalizedRewards.forEach(reward => {
				let foundSameReward = finalRewards.find(r => r.referral_reward_id !== reward.referral_reward_id && r.business_id === reward.business_id && r.user_id === reward.user_id && r.invited_by_user_id === reward.invited_by_user_id);
				if(foundSameReward) {
					let addingAction = reward.action === 'subscription' ? 'completed_subscription' : 'completed_tier';
					foundSameReward[addingAction] = !!reward.completion_date;
					foundSameReward.amount += reward.amount;
					foundSameReward.received += !!reward.completion_date ? reward.amount : 0;
				} else {
					let addingAction = reward.action === 'subscription' ? 'completed_subscription' : 'completed_tier';
					reward[addingAction] = !!reward.completion_date;
					reward.received = !!reward.completion_date ? reward.amount : 0;
					finalRewards.push(reward);
				}
			})
			return finalRewards;
		},
		getReferralsRewards(callback = null, forced = false) {
			if(!forced && this.referralsRewards && this.referralsRewards.length) {
				callback && callback(true);
				return;
			}
			API.init().getUserReferralsRewards(filters, response => {
				if (response && response.result === "OK") {
					if(response.referrals_rewards && response.referrals_rewards.length) {
						this.referralsRewards = this.normalizeRewards(response.referrals_rewards);
					}
				}
				callback && callback(response && response.result === "OK");
			});
		},
		getFilteredReferralsRewards(filters, callback = null) {
			API.init().getUserReferralsRewards(filters, response => {
				if (response && response.result === "OK") {
					if(response.referrals_rewards && response.referrals_rewards.length) {
						this.referralsRewards = this.normalizeRewards(response.referrals_rewards);
						this.totalReferralsRewards = Number(response.total || 0);
					}
				}
				callback && callback(response && response.result === "OK");
			});
		}
	},
});
